export default class EventKey {
	static USER_PILOT_WEB_PAGE_EDITOR_ELEMENT_FOCUSED = 'USER_PILOT_WEB_PAGE_EDITOR_ELEMENT_FOCUSED';
	static USER_PILOT_SAVE_WEB_PAGE = 'USER_PILOT_SAVE_WEB_PAGE';
	static USER_PILOT_WEB_PAGE_EDITOR_DRAG_ELEMENT = 'USER_PILOT_WEB_PAGE_EDITOR_DRAG_ELEMENT';
	static USER_PILOT_SHOW_PROGRESS_BAR = 'USER_PILOT_SHOW_PROGRESS_BAR';
	static USER_CONNECT_MAINFUNCTION_BLOCK = 'USER_CONNECT_MAINFUNCTION_BLOCK';
}
